'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alpha", "alphaClassName", "boardClassName", "colorsClassName", "ribbonClassName", "favorites", "fieldsetSize", "hex", "hexOnly", "hue", "includeAlpha", "mode", "onChange", "onFocus", "onBlur"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import Board from './Board';
import Preview from './Preview';
import Ribbon from './Ribbon';
import AlphaRibbon from './AlphaRibbon';
import Params from './Params';
import FavoritesAccordion from './FavoritesAccordion';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PanelContainer = styled.div.withConfig({
  displayName: "Panel__PanelContainer",
  componentId: "sc-1whel0o-0"
})(["display:flex;position:relative;padding:8px;"]);
const PanelInner = styled.div.withConfig({
  displayName: "Panel__PanelInner",
  componentId: "sc-1whel0o-1"
})(["width:146px;display:flex;flex-direction:column;"]);
const RibbonContainer = styled.div.withConfig({
  displayName: "Panel__RibbonContainer",
  componentId: "sc-1whel0o-2"
})(["display:flex;flex-shrink:0;"]);
const RibbonInner = styled.div.withConfig({
  displayName: "Panel__RibbonInner",
  componentId: "sc-1whel0o-3"
})(["flex-grow:1;"]);
export default class Panel extends Component {
  constructor(...args) {
    super(...args);
    this.onSystemColorPickerOpen = evt => {
      // only works with browsers that support color input
      if (evt.target.type === 'color') {
        this.systemColorPickerOpen = true;
      }
    };
    this.onFocus = () => {
      if (this._blurTimer) {
        clearTimeout(this._blurTimer);
        this._blurTimer = null;
      } else {
        this.props.onFocus();
      }
    };
    this.onBlur = () => {
      if (this._blurTimer) {
        clearTimeout(this._blurTimer);
      }
      this._blurTimer = setTimeout(() => {
        // if is system color picker open, then stop run blur
        if (this.systemColorPickerOpen) {
          this.systemColorPickerOpen = false;
          return;
        }
        this.props.onBlur();
      }, 100);
    };
  }
  renderAlpha({
    alpha,
    alphaClassName,
    hex,
    includeAlpha,
    onChange
  }) {
    if (!includeAlpha) return null;
    return /*#__PURE__*/_jsx(AlphaRibbon, {
      alpha: alpha,
      className: alphaClassName,
      hex: hex,
      onChange: onChange
    });
  }
  render() {
    const _this$props = this.props,
      {
        alpha,
        alphaClassName,
        boardClassName,
        colorsClassName,
        ribbonClassName,
        favorites,
        fieldsetSize,
        hex,
        hexOnly,
        hue,
        includeAlpha,
        mode,
        onChange
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsxs(PanelContainer, Object.assign({}, rest, {
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      tabIndex: "0",
      children: [/*#__PURE__*/_jsxs(PanelInner, {
        "data-test-id": "panel-inner",
        className: colorsClassName,
        children: [/*#__PURE__*/_jsx(Board, {
          className: boardClassName,
          hex: hex,
          hue: hue,
          onChange: onChange
        }), /*#__PURE__*/_jsxs(RibbonContainer, {
          "data-test-id": "ribbon-container",
          className: "m-top-2",
          children: [/*#__PURE__*/_jsxs(RibbonInner, {
            className: "m-right-2",
            children: [/*#__PURE__*/_jsx(Ribbon, {
              hue: hue,
              onChange: onChange,
              className: ribbonClassName,
              includeAlpha: includeAlpha
            }), this.renderAlpha({
              alpha,
              alphaClassName,
              hex,
              includeAlpha,
              onChange
            })]
          }), /*#__PURE__*/_jsx(Preview, {
            alpha: alpha,
            hex: hex,
            onChange: onChange,
            onInputClick: this.onSystemColorPickerOpen
          })]
        }), /*#__PURE__*/_jsx(FavoritesAccordion, {
          onSelectColor: onChange,
          favorites: favorites
        })]
      }), /*#__PURE__*/_jsx(Params, {
        hexOnly: hexOnly,
        includeAlpha: includeAlpha,
        alpha: alpha,
        fieldsetSize: fieldsetSize,
        hex: hex,
        hue: hue,
        onChange: onChange,
        mode: mode
      })]
    }));
  }
}
Panel.propTypes = {
  alpha: PropTypes.number,
  alphaClassName: PropTypes.string,
  boardClassName: PropTypes.string,
  className: PropTypes.string,
  colorsClassName: PropTypes.string,
  favorites: PropTypes.array,
  fieldsetSize: Params.propTypes.fieldsetSize,
  hex: PropTypes.string,
  hexOnly: PropTypes.bool,
  hue: PropTypes.number,
  includeAlpha: PropTypes.bool,
  mode: PropTypes.oneOf(['RGB', 'HSL', 'HSB']),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  ribbonClassName: PropTypes.string
};